<template>
    <div class="park">
        <Title :chineseTitle="$store.state.projectId == 18?'项目概况': '园区概况'" englishTitle="Park profile">
        </Title>
        <div class="parkContent">
            <div class="body top">
                <div class="progressContainer">
                    <div class="progressTitle">日负荷率</div>
                    <div class="progress">
                        <CircleProgress
                            :value="$store.state.load.length == 0 ? '--' : ($store.state.load.find(item => item.projectId == $store.state.projectId).LoadPer/100).toFixed(2)" />
                            <!-- :value="($store.getters.getTotal_p() / $store.state.receivingCapacity).toFixed(2)" /> -->
                        <div class="progressValue">
                            {{$store.state.load.length == 0 ? '--' : ($store.state.load.find(item => item.projectId == $store.state.projectId).LoadPer).toFixed(2) + "%"}}
                        </div>
                    </div>
                    <span
                        class="progressText">{{'容量: ' + $store.state.receivingCapacity}}
                        <span style="font-size: 14rem">kVA </span>
                        <!-- <span>{{'×' + $store.state.transformerNum}}</span> -->
                    </span>
                </div>
                <div class="line"></div>
                <div class="dataContainer">
                    <div class="dataItem top">
                        <div class="title">实时负载</div>
                        <span
                            class="data">{{$store.getters.getTotal_p() == '--' ? '--' : parseFloat($store.getters.getTotal_p().toFixed(2))}}
                            <span style="font-size: 20rem"> kW</span>
                        </span>
                    </div>
                    <div class="dataItem bottom">
                        <div class="title">变压器台数</div>
                        <div class="data">{{$store.state.transformerNum}}</div>
                    </div>
                </div>
            </div>
            <div class="body bottom">
                <div class="lineContainer">
                    <img class="icon" src="../../assets/img/园区地址.png" alt="">
                    <div class="title">{{$store.state.projectId == 18?'项目地址': '园区地址'}}: </div>
                    <div class="content">{{projectAddress}}</div>
                </div>
                <div class="lineContainer">
                    <img class="icon" src="../../assets/img/供电来源.png" alt="">
                    <div class="title">供电来源: </div>
                    <div class="content">{{projectDetailsInfo? projectDetailsInfo['供电来源: '] : ''}}</div>
                </div>
                <div class="lineContainer">
                    <img class="icon" src="../../assets/img/供电公司.png" alt="">
                    <div class="title">供电公司: </div>
                    <div class="content">{{projectDetailsInfo? projectDetailsInfo['管辖单位: '] : ''}}</div>
                </div>
                <div class="lineContainer">
                    <img class="icon" src="../../assets/img/地理位置.png" alt="">
                    <div class="title">地理位置: </div>
                    <div class="content">{{projectDetailsInfo? projectDetailsInfo['地理位置: '] : ''}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title.vue";
    import Item from "@/components/Item";
    import CircleProgress from "@/components/CircleProgress";
    import {
        GetCurrentPowerInfo,
        GetBaseInfo,
    } from "@/components/Request";

    export default {
        name: "ParkOverView",
        components: {
            Title,
            Item,
            CircleProgress,
        },
        props: ["projectId"],
        data() {
            return {
                p_total: 0,
                timer: null,
                projectAddress: '',
                projectPowerOrigin: '',
                projectDetailsInfo: null,
            };
        },
        created() {
            this.getCurrentPowerInfo()
        },
        mounted() {
            // 区域总览信息
            GetBaseInfo({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                this.projectAddress = data.data.project.projectAddress
                this.projectPowerOrigin = data.data.project.projectPowerOrigin
                this.projectAddress = data.data.project.projectAddress
                this.projectDetailsInfo = JSON.parse(data.data.project.projectDetailsInfo)
            })
            this.timer = setInterval(() => {
                this.getCurrentPowerInfo()
            }, 1000 * 60 * 30)
        },
        beforeDestroy() {
            this.timer && clearInterval(this.timer)
            this.timer && (this.timer = null)
        },
        methods: {
            getCurrentPowerInfo() {
                GetCurrentPowerInfo({
                    projectId: this.projectId
                }).then(({
                    data
                }) => {
                    this.p_total = data.data.result.total
                })
            },
        },
    };
</script>

<style lang="less" scoped>
    .park {
        position: fixed;
        top: 880/108vh;
        left: 160/192vw;
    }

    .parkContent {
        margin-left: 112/192vw;
        width: 4080/192vw;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .body {
            .w(400);
            .h(226);
            padding: 300/108vh 300/192vw;
            background: rgba(3, 13, 24, 0.75);
        }

        .top {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .progressContainer {
                width: 49%;
                height: 90%;
                opacity: 0.75;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;

                .progressTitle {
                    font-size: 18rem;
                    font-weight: 400;
                    color: #e6f8ff;
                    opacity: 0.7;
                }

                .progress {
                    width: 1200/192vw;
                    height: 600/192vw;
                    position: relative;

                    .progressValue {
                        // margin-top: -300/108vh;
                        position: absolute;
                        bottom: -5rem;
                        left: 50%;
                        transform: translate(-50%, 0);
                        font-size: 24rem;
                        font-weight: bold;
                        color: #ffffff;
                    }
                }

                .progressText {
                    font-size: 16rem;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.7);
                    white-space: nowrap;
                }
            }

            .line {
                .w(1);
                height: 100%;
                background: rgba(255, 255, 255, 0.3);
            }

            .dataContainer {
                width: 49%;
                height: 90%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .dataItem {
                    width: 100%;
                    height: 50%;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;

                    .title {
                        font-size: 18rem;
                        font-family: Source Han Sans CN;
                        color: rgba(230, 248, 255, 0.7);
                        opacity: 0.7;
                    }

                    .data {
                        font-size: 24rem;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #FFFFFF;
                    }
                }

                .top {
                    justify-content: flex-start;
                }

                .bottom {
                    justify-content: flex-end;
                }
            }

        }

        .bottom {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size: 14rem;
            font-family: Source Han Sans CN;
            font-weight: 300;
            color: rgba(230, 248, 255, 0.7);

            .lineContainer {
                display: flex;
                flex-direction: row;
                // justify-content: space-around;
                align-items: flex-start;

                .icon {
                    .w(24);
                    .h(24);
                }

                .title {
                    // width: 20%;
                    margin-left: 5rem;
                    line-height: 240/108vh;
                    white-space: nowrap;
                }

                .content {
                    // width: 75%;
                    margin-left: 5rem;
                    line-height: 240/108vh;
                }
            }
        }
    }

    .body {
        margin-left: 80/192vw;
        margin-top: 80/108vh;
        overflow: hidden;

        .errorContainer {
            width: 1960/192vw;
            height: 1500/108vh;
            background: #030d18;
            opacity: 0.75;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
        }

        .errorDataContainer {
            width: 1200/192vw;
            display: flex;
            flex-direction: row;
            align-items: baseline;
            justify-content: space-between;

            .errorName {
                font-size: 18rem;
                color: #e6f8ff;
                opacity: 0.7;
            }

            .errorData {
                font-size: 30rem;
                color: #fff
            }
        }
    }
</style>